// extracted by mini-css-extract-plugin
module.exports = {"team__right__content":"page_team__right__content__xeZWE","team__right__toolbar":"page_team__right__toolbar__8RtJ0","team__right__teamslist":"page_team__right__teamslist__c_gDQ"};